import React from "react";
import companyInfo from "../../../themes/themes";
import Typography from "@material-ui/core/Typography";

export default function ExpirationWarning() {
  const theme = process.env.REACT_APP_THEME;

  return (
    <Typography>
      {companyInfo[theme]?.company} is limited in the number of Growth Plans it
      can support at any given time. If you do not take action, your Plan will
      be archived and you’ll be eligible to re-apply for a Growth Plan in a
      future slot.
    </Typography>
  );
}
